import { useState } from "react";
import { RichTextEditor } from "@mantine/rte";

const Editor = (props: any) => {
  const { value, onChange } = props;
  return <RichTextEditor value={value} onChange={onChange} />;
};

export default Editor;
